import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import Bookmarks from "./Bookmarks";
import Parchment from "./Parchment";
import HomeChapter from "./chapters/Home";
import LibriLetti from "./chapters/LibriLetti";
import FutureLetture from "./chapters/Future";
import Recensioni from "./chapters/Recensioni";
import Calendario from "./chapters/Calendario";
import Eventi from "./chapters/Eventi";
import SpinOff from "./chapters/SpinOff";
import Contatti from "./chapters/Contatti";
import { CHAPTERS } from "@/data";

const PAGES = {
    home: HomeChapter,
    libri: LibriLetti,
    future: FutureLetture,
    recensioni: Recensioni,
    calendario: Calendario,
    eventi: Eventi,
    spinoff: SpinOff,
    contatti: Contatti,
};

export default function BookShell() {
    const [chapterId, setChapterId] = useState("home");
    const scrollRef = useRef(null);
    const contentRef = useRef(null);
    const lenisRef = useRef(null);
    const dirRef = useRef(1);

    const idx = CHAPTERS.findIndex((c) => c.id === chapterId);
    const chapter = CHAPTERS[idx];

    const go = (id) => {
        if (id === chapterId) return;
        const ni = CHAPTERS.findIndex((c) => c.id === id);
        dirRef.current = ni >= idx ? 1 : -1;
        setChapterId(id);
    };

    useEffect(() => {
        const lenis = new Lenis({
            wrapper: scrollRef.current,
            content: contentRef.current,
            duration: 1.15,
        });
        lenisRef.current = lenis;
        let rafId;
        const raf = (t) => {
            lenis.raf(t);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    useEffect(() => {
        lenisRef.current?.scrollTo(0, { immediate: true });
        scrollRef.current?.scrollTo(0, 0);
    }, [chapterId]);

    const dir = dirRef.current;
    const Body = PAGES[chapter.id];

    return (
        <motion.div
            className="h-screen w-full overflow-hidden desk-bg"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            data-testid="book-shell"
        >
            <Bookmarks value={chapter.id} onChange={go} />
            <main
                ref={scrollRef}
                className="page-viewport relative h-full md:ml-[252px] pt-[54px] md:pt-0 overflow-y-auto overflow-x-hidden"
                style={{ perspective: "2400px" }}
                data-testid="page-viewport"
            >
                <div ref={contentRef} className="min-h-full">
                    <AnimatePresence mode="wait">
                        <motion.div
                            key={chapter.id}
                            className="min-h-full"
                            initial={{ rotateY: 70 * dir, opacity: 0 }}
                            animate={{ rotateY: 0, opacity: 1, transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] } }}
                            exit={{ rotateY: -75 * dir, opacity: 0, transition: { duration: 0.42, ease: [0.55, 0, 0.55, 0.2] } }}
                            style={{ transformOrigin: "left center", transformStyle: "preserve-3d" }}
                        >
                            <Parchment chapter={chapter}>
                                <Body go={go} />
                            </Parchment>
                        </motion.div>
                    </AnimatePresence>
                </div>
            </main>
        </motion.div>
    );
}
